// Placeholder — generic "coming soon" page for legacy menu routes not yet ported.
import { useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import { EmptyState } from '../ui/index.js';
import { NAV_GROUPS, findActiveMenuMatch } from './menu.js';

// WHY: Topbar carries the parent group label. Without a per-route H1,
// sibling Placeholder routes inside the same group are visually identical,
// so we render the matched item's label as the H1.
export function Placeholder() {
  const { t } = useTranslation('shell');
  const { pathname } = useLocation();
  const item = findActiveMenuMatch(pathname, NAV_GROUPS)?.item ?? null;
  return (
    <div style={{ padding: '18px 24px 12px' }}>
      {item && <h1 style={{ fontSize: 20, fontWeight: 600, margin: 0 }}>{t(item.label)}</h1>}
      <EmptyState icon="sparkles" title={t('placeholder.title')} text={t('placeholder.text')} />
    </div>
  );
}
